import { styled } from "goober";
import { type ReactElement, useContext } from "react";
import {
  ActivityAnimationContext,
  activityAnimationPeriod,
  alignToTimeline,
} from "../ActivityAnimationContext";
import { spin } from "../motion";
import { Icon, type IconName } from "../Icon";
import { PulsingIcon } from "../PulsingIcon";
import { ShimmerSpan } from "../ShimmerSpan";
import { Text } from "../Text";
import { TypewriterSpan } from "../TypewriterSpan";

const SpinningIcon = styled("span")`
  display: flex;
  &[data-spinning="true"] {
    animation: ${spin} ${activityAnimationPeriod} linear infinite;
  }
`;

type Props = {
  icon: IconName | ReactElement;
  text: string;
  pending?: boolean;
  iconColor?: string;
};

export function ToolStatus({
  icon,
  text,
  pending = false,
  iconColor = "var(--text-secondary)",
}: Props) {
  // Keep live activity animated between tool completions, while standalone rows follow their own pending state.
  const animated = useContext(ActivityAnimationContext)?.live ?? pending;
  return (
    <>
      <PulsingIcon data-pending={animated}>
        {typeof icon === "string" ? (
          <SpinningIcon
            data-spinning={animated && icon === "circle-dashed"}
            onAnimationStart={alignToTimeline}
          >
            <Icon name={icon} size={12} color={iconColor} />
          </SpinningIcon>
        ) : (
          icon
        )}
      </PulsingIcon>
      <Text variant="text-small" color="var(--text-secondary)" ellipsis>
        <ShimmerSpan data-pending={animated}>
          <TypewriterSpan>{text}</TypewriterSpan>
        </ShimmerSpan>
      </Text>
    </>
  );
}
